/**
 * Ray's Loyalty — birthday gifts & monthly coupon club sections (Luvme-style layout).
 */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function tReplace(str, vars) {
    var s = String(str || '');
    Object.keys(vars || {}).forEach(function (key) {
      var val = vars[key] != null ? String(vars[key]) : '';
      s = s.replace(new RegExp('\\[\\[\\s*' + key + '\\s*\\]\\]', 'g'), val);
      s = s.replace(new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g'), val);
    });
    return s;
  }

  function monthName(m, locale) {
    if (!m || m < 1 || m > 12) return '';
    try {
      return new Date(2000, m - 1, 1).toLocaleString(locale || undefined, {
        month: 'long',
      });
    } catch (e) {
      return String(m);
    }
  }

  function openLogin() {
    if (window.RaysLoyalty && typeof window.RaysLoyalty.openAccountSheet === 'function') {
      window.RaysLoyalty.openAccountSheet();
      return;
    }
    if (window.RlAccountSheet && typeof window.RlAccountSheet.open === 'function') {
      window.RlAccountSheet.open();
      return;
    }
    var url = window.__RAYS_LOYALTY__ && window.__RAYS_LOYALTY__.loginUrl;
    if (url) window.location.href = url;
  }

  function getPreviewHtml(root) {
    var tpl = root.querySelector('[data-rl-club-preview-template]');
    if (!tpl) return '';
    var list = tpl.content
      ? tpl.content.querySelector('.rl-club-gifts__picture-list')
      : tpl.querySelector('.rl-club-gifts__picture-list');
    return list ? list.outerHTML : '';
  }

  function firstPreviewImgSrc(root) {
    var tpl = root.querySelector('[data-rl-club-preview-template]');
    if (!tpl) return '';
    var img = tpl.content
      ? tpl.content.querySelector('.rl-club-gifts__picture-item img')
      : tpl.querySelector('.rl-club-gifts__picture-item img');
    return img && img.getAttribute('src') ? img.getAttribute('src') : '';
  }

  function logoHtml(src, alt) {
    if (src) {
      return (
        '<div class="rl-club-gifts__logo"><img src="' +
        esc(src) +
        '" alt="' +
        esc(alt || '') +
        '" loading="lazy" width="90" height="48"></div>'
      );
    }
    return '<div class="rl-club-gifts__logo" aria-hidden="true"></div>';
  }

  function renderRowGroup(picturesHtml, actionHtml, hintText) {
    var hint =
      hintText != null && hintText !== ''
        ? '<p class="rl-club-gifts__row-hint">' + esc(hintText) + '</p>'
        : '';
    return (
      '<div class="rl-club-gifts__content__row-group">' +
      (picturesHtml || '') +
      (actionHtml || '') +
      hint +
      '</div>'
    );
  }

  function renderColGroup(logoSrc, label, actionHtml, alt) {
    var labelText = String(label == null ? '' : label).trim();
    var labelHtml =
      labelText !== ''
        ? '<div class="rl-club-gifts__field__label">' + esc(labelText) + '</div>'
        : '';
    return (
      '<div class="rl-club-gifts__content__col-group">' +
      logoHtml(logoSrc, alt) +
      '<div class="rl-club-gifts__field">' +
      labelHtml +
      (actionHtml || '') +
      '</div>' +
      '</div>'
    );
  }

  function setDynamic(root, html, mode) {
    var elContent = root.querySelector('[data-rl-club-content]');
    var elDynamic = root.querySelector('[data-rl-club-dynamic]');
    if (elContent) {
      elContent.classList.toggle('rl-club-gifts__content--cols', mode === 'cols');
    }
    if (elDynamic) {
      elDynamic.innerHTML = html || '';
    }
  }

  function initBirthdaySection(root) {
    if (!root || root.dataset.rlBound) return;
    root.dataset.rlBound = '1';
    var cfg;
    try {
      cfg = JSON.parse(
        root.querySelector('[data-rl-club-config]')?.textContent || '{}'
      );
    } catch (e) {
      cfg = {};
    }
    var I = cfg.strings || {};
    var locale = cfg.locale || '';
    var elLoading = root.querySelector('[data-rl-club-loading]');
    var elBody = root.querySelector('[data-rl-club-body]');
    var previews = getPreviewHtml(root);
    var logoSrc = firstPreviewImgSrc(root);

    function setLoading(on) {
      if (elLoading) elLoading.hidden = !on;
      if (elBody) elBody.hidden = !!on;
    }

    function btnPrimary(text, opts) {
      opts = opts || {};
      var cls = 'rl-club-gifts__handler';
      if (opts.ghost) cls += ' rl-club-gifts__handler--ghost';
      if (opts.disabled) {
        return (
          '<button type="button" class="' +
          cls +
          '" disabled aria-disabled="true">' +
          esc(text) +
          '</button>'
        );
      }
      if (opts.href) {
        return (
          '<a class="' +
          cls +
          (opts.ghost ? ' rl-club-gifts__handler--ghost' : '') +
          '" href="' +
          esc(opts.href) +
          '">' +
          esc(text) +
          '</a>'
        );
      }
      return (
        '<button type="button" class="' +
        cls +
        ' js-rays-open-shopify-account" data-rl-club-cta data-rl-open-login aria-haspopup="dialog">' +
        esc(text) +
        '</button>'
      );
    }

    function bindCta(fn) {
      var el = root.querySelector('[data-rl-club-cta]');
      if (el) el.onclick = fn;
    }

    function render(b) {
      if (!b) return;
      var state = b.state || 'guest';

      if (state === 'guest') {
        setDynamic(
          root,
          renderRowGroup(previews, btnPrimary(I.ctaLogin || 'Sign in'), I.hintGuest),
          'row'
        );
        return;
      }

      if (state === 'not_filled') {
        var fillBtn = cfg.profileUrl
          ? btnPrimary(I.ctaFillBirthday || 'Add birthday', {
              href: cfg.profileUrl,
              ghost: true,
            })
          : btnPrimary(I.ctaFillBirthday || 'Add birthday', { ghost: true });
        setDynamic(
          root,
          renderRowGroup(previews, fillBtn, I.hintNotFilled),
          'row'
        );
        return;
      }

      if (state === 'not_birth_month') {
        var bm = b.birthMonth ? monthName(b.birthMonth, locale) : '';
        var timeHtml =
          '<span class="rl-club-gifts__time">' +
          esc(tReplace(I.hintNotBirthMonth || '', { month: bm })) +
          '</span>';
        setDynamic(
          root,
          renderRowGroup(previews, timeHtml, ''),
          'row'
        );
        return;
      }

      if (state === 'claimed') {
        var claimedLabel = I.hintClaimed || '';
        if (b.rewardMode === 'gift_card' && b.giftCardAmountCentsGranted) {
          claimedLabel = tReplace(I.hintClaimedGiftCard || '', {
            amount: (b.giftCardAmountCentsGranted / 100).toFixed(2),
          });
        } else if (b.pointsGranted) {
          claimedLabel = tReplace(I.hintClaimedPoints || '', {
            points: b.pointsGranted,
          });
        }
        var claimedAction =
          '<span class="rl-club-gifts__field__used">' +
          esc(I.ctaClaimed || 'Received') +
          '</span>';
        setDynamic(
          root,
          renderColGroup(logoSrc, claimedLabel, claimedAction),
          'cols'
        );
        return;
      }

      if (state === 'no_rule') {
        setDynamic(
          root,
          renderRowGroup(
            previews,
            btnPrimary(I.ctaUnavailable || 'Unavailable', { disabled: true }),
            I.hintNoRule
          ),
          'row'
        );
        return;
      }

      if (state === 'ready') {
        var readyHint = I.hintReady || '';
        if (b.rewardMode === 'gift_card' && b.giftCardAmountCents) {
          readyHint = tReplace(I.hintReadyGiftCard || '', {
            amount: (b.giftCardAmountCents / 100).toFixed(2),
          });
        } else if (b.pointsPreview) {
          readyHint = tReplace(I.hintReadyPoints || '', {
            points: b.pointsPreview,
          });
        }
        setDynamic(
          root,
          renderRowGroup(
            previews,
            btnPrimary(I.ctaClaim || 'Get my birthday gift'),
            readyHint
          ),
          'row'
        );
        bindCta(function (e) {
          e.preventDefault();
          var elCta = root.querySelector('[data-rl-club-cta]');
          if (!window.RaysLoyalty || !window.RaysLoyalty.postBirthdayClaim) return;
          if (elCta) elCta.disabled = true;
          window.RaysLoyalty.postBirthdayClaim()
            .then(function (res) {
              if (res && res.status) render(res.status);
              if (
                res &&
                res.ok &&
                window.RaysLoyaltyNotify &&
                window.RaysLoyaltyNotify.poll
              ) {
                window.setTimeout(function () {
                  window.RaysLoyaltyNotify.poll();
                }, 800);
              }
              if (!res || !res.ok) {
                if (
                  window.RaysLoyaltyNotify &&
                  window.RaysLoyaltyNotify.toastError
                ) {
                  window.RaysLoyaltyNotify.toastError(
                    I.errorClaim || 'Could not claim gift'
                  );
                }
                if (elCta) elCta.disabled = false;
              }
            })
            .catch(function () {
              if (
                window.RaysLoyaltyNotify &&
                window.RaysLoyaltyNotify.toastError
              ) {
                window.RaysLoyaltyNotify.toastError(
                  I.errorClaim || 'Could not claim gift'
                );
              }
              if (elCta) elCta.disabled = false;
            });
        });
      }
    }

    function refresh() {
      if (!window.RaysLoyalty || !window.RaysLoyalty.getClubBenefits) {
        setLoading(false);
        setDynamic(
          root,
          renderRowGroup('', '<p class="rl-club-gifts__row-hint">' + esc(I.errorLoad || '') + '</p>'),
          'row'
        );
        return;
      }
      setLoading(true);
      window.RaysLoyalty.getClubBenefits()
        .then(function (data) {
          render(data && data.birthday);
        })
        .catch(function () {
          setDynamic(
            root,
            renderRowGroup('', '<p class="rl-club-gifts__row-hint">' + esc(I.errorLoad || '') + '</p>'),
            'row'
          );
        })
        .finally(function () {
          setLoading(false);
        });
    }

    refresh();
    document.addEventListener('rays-loyalty:customer-id', refresh);
    document.addEventListener('shopify:section:load', function (ev) {
      if (ev.detail && ev.detail.sectionId === cfg.sectionId) refresh();
    });
  }

  function initMonthlySection(root) {
    if (!root || root.dataset.rlBound) return;
    root.dataset.rlBound = '1';
    var cfg;
    try {
      cfg = JSON.parse(
        root.querySelector('[data-rl-club-config]')?.textContent || '{}'
      );
    } catch (e) {
      cfg = {};
    }
    var I = cfg.strings || {};
    var elLoading = root.querySelector('[data-rl-club-loading]');
    var elBody = root.querySelector('[data-rl-club-body]');
    var previews = getPreviewHtml(root);
    var logoSrc = firstPreviewImgSrc(root);

    function setLoading(on) {
      if (elLoading) elLoading.hidden = !on;
      if (elBody) elBody.hidden = !!on;
    }

    function btnPrimary(text, opts) {
      opts = opts || {};
      var cls = 'rl-club-gifts__handler';
      if (opts.disabled) {
        return (
          '<button type="button" class="' +
          cls +
          '" disabled aria-disabled="true">' +
          esc(text) +
          '</button>'
        );
      }
      return (
        '<button type="button" class="' +
        cls +
        ' js-rays-open-shopify-account" data-rl-club-cta data-rl-open-login aria-haspopup="dialog">' +
        esc(text) +
        '</button>'
      );
    }

    function bindCta(fn) {
      var el = root.querySelector('[data-rl-club-cta]');
      if (el) el.onclick = fn;
    }

    function bindCopy(code) {
      var copyBtn = root.querySelector('[data-rl-club-copy]');
      if (!copyBtn || !code) return;
      copyBtn.onclick = function () {
        var done = function () {
          copyBtn.textContent = I.copied || 'Copied';
          window.setTimeout(function () {
            copyBtn.textContent = I.copy || 'Copy';
          }, 1800);
        };
        if (window.RaysLoyalty && window.RaysLoyalty.copyToClipboard) {
          window.RaysLoyalty.copyToClipboard(code).then(done).catch(done);
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        }
      };
    }

    function isUnusedCouponStatus(status) {
      var s = String(status || '').toLowerCase();
      return (
        s === 'issued' ||
        s === 'unused' ||
        s === 'active' ||
        s === 'available'
      );
    }

    function findMonthlyCoupon(couponsPayload, monthlyHandle) {
      if (!couponsPayload || !Array.isArray(couponsPayload.personal)) return null;
      var handle = String(monthlyHandle || '').trim();
      for (var i = 0; i < couponsPayload.personal.length; i++) {
        var c = couponsPayload.personal[i] || {};
        var code = c.code != null ? String(c.code).trim() : '';
        if (!code || !isUnusedCouponStatus(c.status)) continue;
        var spendHandle =
          c.spendRuleHandle != null ? String(c.spendRuleHandle).trim() : '';
        if (handle && spendHandle && spendHandle === handle) return c;
      }
      return null;
    }

    function render(m, matchedCoupon) {
      if (!m) return;
      var state = m.state || 'guest';
      var title = m.title || '';
      var pct = m.discountPercent != null ? m.discountPercent + '%' : '';
      var couponCode =
        matchedCoupon && matchedCoupon.code != null
          ? String(matchedCoupon.code).trim()
          : '';

      if (state !== 'guest' && couponCode !== '') {
        var couponTitle =
          (matchedCoupon && matchedCoupon.title
            ? String(matchedCoupon.title)
            : '') || title || 'Monthly VIP coupon';
        setDynamic(
          root,
          renderColGroup(
            logoSrc,
            '',
            '<span class="rl-club-gifts__field__used rl-club-gifts__field__used-code">' +
              esc(couponCode) +
              '</span>' +
              '<button type="button" class="rl-club-gifts__field__handler" data-rl-club-copy>' +
              esc(I.copy || 'Copy') +
              '</button>'
          ),
          'cols'
        );
        bindCopy(couponCode);
        return;
      }

      if (state === 'guest') {
        setDynamic(
          root,
          renderRowGroup(previews, btnPrimary(I.ctaLogin || 'Sign in'), I.hintGuest),
          'row'
        );
        return;
      }

      if (state === 'unconfigured') {
        setDynamic(
          root,
          renderRowGroup(
            previews,
            btnPrimary(I.ctaUnavailable || 'Unavailable', { disabled: true }),
            I.hintUnconfigured
          ),
          'row'
        );
        return;
      }

      if (state === 'claimed') {
        var claimedLabel = tReplace(I.hintClaimed || '', {
          title: title,
          percent: pct,
        });
        var claimedAction =
          couponCode !== ''
            ? '<span class="rl-club-gifts__field__used rl-club-gifts__field__used-code">' +
              esc(couponCode) +
              '</span>' +
              '<button type="button" class="rl-club-gifts__field__handler" data-rl-club-copy>' +
              esc(I.copy || 'Copy') +
              '</button>'
            : '<span class="rl-club-gifts__field__used">' +
              esc(I.ctaClaimed || 'Claimed this month') +
              '</span>';
        setDynamic(
          root,
          renderColGroup(
            logoSrc,
            couponCode !== '' ? '' : claimedLabel,
            claimedAction
          ),
          'cols'
        );
        if (couponCode) bindCopy(couponCode);
        return;
      }

      if (state === 'insufficient_points') {
        setDynamic(
          root,
          renderRowGroup(
            previews,
            btnPrimary(I.ctaInsufficient || 'Not enough points', { disabled: true }),
            tReplace(I.hintInsufficient || '', {
              title: title,
              points: m.pointsCost,
            })
          ),
          'row'
        );
        return;
      }

      if (state === 'out_of_stock') {
        setDynamic(
          root,
          renderRowGroup(
            previews,
            btnPrimary(I.ctaOos || 'Out of stock', { disabled: true }),
            I.hintOos
          ),
          'row'
        );
        return;
      }

      if (state === 'ready') {
        setDynamic(
          root,
          renderRowGroup(
            previews,
            btnPrimary(tReplace(I.ctaRedeem || 'Redeem', { points: m.pointsCost })),
            tReplace(I.hintReady || '', {
              title: title,
              percent: pct,
              points: m.pointsCost,
            })
          ),
          'row'
        );
        bindCta(function (e) {
          e.preventDefault();
          var elCta = root.querySelector('[data-rl-club-cta]');
          if (!window.RaysLoyalty) return;
          if (elCta) elCta.disabled = true;
          if ((m.pointsCost == null || Number(m.pointsCost) <= 0) && window.RaysLoyalty.getClubBenefits) {
            refresh();
            return;
          }
          if (!m.handle || !window.RaysLoyalty.postRedeem) {
            if (elCta) elCta.disabled = false;
            return;
          }
          window.RaysLoyalty.postRedeem(m.handle)
            .then(function (res) {
              var meta = {
                title: title,
                rewardType: m.rewardType,
                pointsCost: m.pointsCost,
              };
              if (window.RlRedeemSuccess && cfg.redeemDialogId) {
                window.RlRedeemSuccess.show(cfg.redeemDialogId, res, meta, {
                  onClose: function () {
                    refresh();
                  },
                });
              } else {
                refresh();
              }
            })
            .catch(function (err) {
              var msg = I.errorRedeem || 'Redeem failed';
              try {
                if (err && err.body && err.body.error) msg = String(err.body.error);
              } catch (_e) {}
              if (window.RaysLoyaltyNotify && window.RaysLoyaltyNotify.toastError) {
                window.RaysLoyaltyNotify.toastError(msg);
              }
              if (elCta) elCta.disabled = false;
            });
        });
      }
    }

    function refresh() {
      if (!window.RaysLoyalty || !window.RaysLoyalty.getClubBenefits) {
        setLoading(false);
        return;
      }
      setLoading(true);
      var opts = cfg.monthlyHandle ? { monthlyHandle: cfg.monthlyHandle } : {};
      Promise.all([
        window.RaysLoyalty.getClubBenefits(opts),
        window.RaysLoyalty.getCoupons
          ? window.RaysLoyalty.getCoupons().catch(function () {
              return null;
            })
          : Promise.resolve(null),
      ])
        .then(function (res) {
          var benefits = res && res[0] ? res[0] : null;
          var coupons = res && res[1] ? res[1] : null;
          var monthly = benefits && benefits.monthly ? benefits.monthly : null;
          var monthlyCoupon = findMonthlyCoupon(coupons, cfg.monthlyHandle);
          render(monthly, monthlyCoupon);
        })
        .catch(function () {
          setDynamic(
            root,
            renderRowGroup('', '<p class="rl-club-gifts__row-hint">' + esc(I.errorLoad || '') + '</p>'),
            'row'
          );
        })
        .finally(function () {
          setLoading(false);
        });
    }

    refresh();
    document.addEventListener('rays-loyalty:customer-id', refresh);
    document.addEventListener('shopify:section:load', function (ev) {
      if (ev.detail && ev.detail.sectionId === cfg.sectionId) refresh();
    });
  }

  function boot() {
    document.querySelectorAll('[data-rl-birthday-gifts]').forEach(initBirthdaySection);
    document.querySelectorAll('[data-rl-monthly-gifts]').forEach(initMonthlySection);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
